export default {
  borderRadius: '4px',
  font: 'acumin-pro, "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSize: '16px',
  footerHeight: '35px',
  headerHeight: '50px',
  navSize: '50px',
  navTransition: '350ms ease left'
};



// WEBPACK FOOTER //
// ./src/config/settings.js